import { createSlice } from "@reduxjs/toolkit";
import { setRoleWiseMenu, clearRoleWiseMenu } from "./roleWiseMenuSlice";

const initialState = {
  activeMenuId: "",
  activeMenuLabel: "",
  isSecondaryMenuOpen: false,
  hasSubmenu: false,
};

const secondaryMenuSlice = createSlice({
  name: "secondaryMenu",
  initialState,
  reducers: {
    openSecondaryMenu: (state) => {
      state.isSecondaryMenuOpen = true;
    },
    closeSecondaryMenu: (state) => {
      state.isSecondaryMenuOpen = false;
    },
    toggleSecondaryMenu: (state) => {
      state.isSecondaryMenuOpen = !state.isSecondaryMenuOpen;
    },
    setActiveMenu: (state, action) => {
      return { ...state, ...action.payload };
    },
  },

  extraReducers: (builder) => {
    builder.addCase(setRoleWiseMenu, (state, action) => {
      const menus = action.payload?.menus || [];
      if (!menus.length) return;

      if (state.activeMenuId) {
        const stillExists = menus.some((m) => m._id === state.activeMenuId);
        const hasChildren = menus.some(
          (child) => child.parent_id === state.activeMenuId,
        );

        if (stillExists && hasChildren) {
          state.isSecondaryMenuOpen = true;
          state.hasSubmenu = true;
          return;
        }
      }

      const firstWithChildren = menus
        .filter((m) => !m.parent_id)
        .find((parent) =>
          menus.some((child) => child.parent_id === parent._id),
        );

      if (firstWithChildren) {
        state.activeMenuId = firstWithChildren._id;
        state.activeMenuLabel = firstWithChildren.name || "";
        state.isSecondaryMenuOpen = true;
        state.hasSubmenu = true;
      }
    });

    builder.addCase(clearRoleWiseMenu, () => initialState);
  },
});

export const {
  openSecondaryMenu,
  closeSecondaryMenu,
  toggleSecondaryMenu,
  setActiveMenu,
} = secondaryMenuSlice.actions;

export default secondaryMenuSlice.reducer;
